/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './cerf-edit.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../utilities/components/centered-spinner/centered-spinner.component.ngfactory';
import * as i3 from '../../../../../../app/modules/utilities/components/centered-spinner/centered-spinner.component';
import * as i4 from '../cerf-form/cerf-form.component.ngfactory';
import * as i5 from '../../../../../../app/modules/cerf/components/cerf-form/cerf-form.component';
import * as i6 from '@angular/material';
import * as i7 from '@angular/router';
import * as i8 from '../../../../../../app/modules/cerf/services/cerf/cerf.service';
import * as i9 from '../../../../../../app/modules/user/services/current-user/current-user.service';
import * as i10 from '../../../../../../app/modules/airport/services/airport/airport.service';
import * as i11 from 'angular-crumbs/breadcrumb.service';
import * as i12 from '@angular/forms';
import * as i13 from '../../../../../../app/modules/utilities/FormUtilities';
import * as i14 from '@angular/common';
import * as i15 from '../../../../../../app/modules/cerf/components/cerf-edit/cerf-edit.component';
const styles_CerfEditComponent:any[] = [i0.styles];
export const RenderType_CerfEditComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CerfEditComponent,data:{}});
function View_CerfEditComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-centered-spinner',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_CenteredSpinnerComponent_0,
      i2.RenderType_CenteredSpinnerComponent)),i1.ɵdid(1,49152,(null as any),0,i3.CenteredSpinnerComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
function View_CerfEditComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-cerf-form',
      [['label','View Cerf Request']],(null as any),(null as any),(null as any),i4.View_CerfFormComponent_0,
      i4.RenderType_CerfFormComponent)),i1.ɵdid(1,114688,(null as any),0,i5.CerfFormComponent,
      [i6.MdDialog,i7.ActivatedRoute,i8.CerfService,i9.CurrentUserService,i10.AirportService,
          i7.Router,i11.BreadcrumbService,i12.FormBuilder,i13.FormUtilities,i6.MdSnackBar],
      {label:[0,'label'],cerf:[1,'cerf'],originalExistingFiles:[2,'originalExistingFiles'],
          cerfId:[3,'cerfId']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'View Cerf Request';
    const currVal_1:any = _co.cerf;
    const currVal_2:any = _co.existingFiles;
    const currVal_3:any = _co.cerfId;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
export function View_CerfEditComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_CerfEditComponent_1)),i1.ɵdid(1,16384,(null as any),0,i14.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_CerfEditComponent_2)),i1.ɵdid(4,16384,(null as any),0,i14.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i15.CerfEditComponent = _v.component;
    const currVal_0:boolean = !_co.cerf;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.cerf;
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_CerfEditComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-cerf-edit',
      ([] as any[]),(null as any),(null as any),(null as any),View_CerfEditComponent_0,
      RenderType_CerfEditComponent)),i1.ɵdid(1,114688,(null as any),0,i15.CerfEditComponent,
      [i7.ActivatedRoute,i8.CerfService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CerfEditComponentNgFactory:i1.ComponentFactory<i15.CerfEditComponent> = i1.ɵccf('app-cerf-edit',
    i15.CerfEditComponent,View_CerfEditComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2NlcmYvY29tcG9uZW50cy9jZXJmLWVkaXQvY2VyZi1lZGl0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy9jZXJmL2NvbXBvbmVudHMvY2VyZi1lZGl0L2NlcmYtZWRpdC5jb21wb25lbnQudHMiLCJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy9jZXJmL2NvbXBvbmVudHMvY2VyZi1lZGl0L2NlcmYtZWRpdC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2NlcmYvY29tcG9uZW50cy9jZXJmLWVkaXQvY2VyZi1lZGl0LmNvbXBvbmVudC50cy5DZXJmRWRpdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhcHAtY2VudGVyZWQtc3Bpbm5lciAqbmdJZj1cIiFjZXJmXCI+PC9hcHAtY2VudGVyZWQtc3Bpbm5lcj5cbjxhcHAtY2VyZi1mb3JtIGxhYmVsPVwiVmlldyBDZXJmIFJlcXVlc3RcIiBbY2VyZl09XCJjZXJmXCIgW29yaWdpbmFsRXhpc3RpbmdGaWxlc109XCJleGlzdGluZ0ZpbGVzXCIgW2NlcmZJZF09XCJjZXJmSWRcIiAqbmdJZj1cImNlcmZcIj48L2FwcC1jZXJmLWZvcm0+XG4iLCI8YXBwLWNlcmYtZWRpdD48L2FwcC1jZXJmLWVkaXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzRDQUFBLFVBQUE7TUFBQTs7O29CQUNBO01BQUE7cUNBQUEsVUFBQTtNQUFBO3lGQUFBO01BQUE7VUFBQTs7SUFBZTtJQUEwQjtJQUFjO0lBQXdDO0lBQS9GLFdBQWUsVUFBMEIsVUFBYyxVQUF3QyxTQUEvRjs7OztvQkFEQTtNQUFBLGtDQUFBO29CQUFBLG1DQUEyRDtNQUFBLFNBQzNEO01BQUEsa0NBQUE7b0JBQUEsbUNBQThJO01BQUE7O0lBRHhIO0lBQXRCLFdBQXNCLFNBQXRCO0lBQ2lIO0lBQWpILFdBQWlILFNBQWpIOzs7O29CQ0RBO01BQUE7a0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/cerf/components/cerf-edit/cerf-edit.component.ngfactory.ts